/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetOrgOptions, AdminGetOrgResponses } from '../../models/AdminGetOrg'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Org
 * {@link /admin/org/:org_id}
 */
export function adminGetOrg<ThrowOnError extends boolean = true>(options: Options<AdminGetOrgOptions, ThrowOnError>): Promise<UnwrappedResult<AdminGetOrgResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/org/{org_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetOrgResponses, ThrowOnError>>
}
